// extracted by mini-css-extract-plugin
export var pillWrapper = "_pl-0";
export var showOverflow = "_pl-1";